<script setup lang="ts">

import type { IMarketplaceCategory, IOfferTile } from "@domain/Marketplace";
import { OfferTile } from "@app/MyMarketplace";
import { OfferHeaderStyle } from "@app/MyMarketplace/Types/OfferHeaderStyle";

type Props = { 
    title?: string, 
    subTitle?: string, 
    unfilteredCount?: number,
    totalCount?: number, 
    groups?: IMarketplaceCategory[] 
};
const model = defineModel<IOfferTile[]>( { required: true } );
const { title, subTitle, totalCount = 0, groups = [] } = defineProps<Props>();
const emit = defineEmits( [ 'load-more'] );

const groupedOffers = ( category: IMarketplaceCategory ) => model.value.filter( o => o.categoryId == category.categoryId );

</script>

<template>

    <div class="apple-fix w-full min-h-full">

        <h1 v-if="title"
            class="px-4 3xl:px-6 mb-2 3xl:mb-3 flex items-center justify-between tracking-wider text-base 3xl:text-xl">
            <span>{{ title }}</span>
        </h1>

        <!-- LIST IS DIVIDED INTO SUB CATEGORIES -->
        <div v-if="groups.length > 1">
            <div v-for="group in groups"
                 :key="group.categoryId"
                 class="mb-4 lg:mb-6 3xl:mb-10">
                <div v-if="groupedOffers( group ).length > 0"
                     class="flex flex-col gap-y-4 lg:gap-y-6 3xl:gap-y-10">
                    <div class="px-4 3xl:px-6 text-lg pb-3 mt-8 -mb-4 lg:-mb-6 3xl:-mb-10 first:mt-0 font-semibold z-10">
                        {{ group.name }}
                    </div>
                    <div v-for="(offer, index) in groupedOffers( group )" 
                         :key="offer.offerId">
                        <div class="absolute left-0 top-0 w-full h-36
                                    bg-gradient-to-b from-gray-900 via-30% via-gray-850/50 to-gray-900">
                        </div>
                        <div class="px-4 3xl:px-6 z-10 ">
                            <OfferTile :offer="offer" :header-style="OfferHeaderStyle.Large" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- JUST LIST THE OFFERS -->
        <div v-else>
            <div v-for="(offer, index) in model" 
                 :key="offer.offerId"
                 class="mb-4 lg:mb-6 3xl:mb-10">
                <div class="absolute left-0 top-0 w-full h-36
                            bg-gradient-to-b from-gray-900 via-30% via-gray-850/70 to-gray-900">
                </div>
                <div class="px-4 3xl:px-6 z-10">
                    <OfferTile :offer="offer" :header-style="OfferHeaderStyle.Large" />
                </div>
            </div>
        </div>
           
        <div v-if="( unfilteredCount ?? totalCount ) < totalCount" class="flex justify-center pt-6">
            <Button variant="tonal"
                    class="!h-10 3xl:!h-12 min-w-[50%]"
                    @click="() => emit( 'load-more' )">
                Load more
            </Button>
        </div>

    </div>
    
</template>